import theme from '../../../lib/theme';
import { AdhesionAdProps } from './AdhesionAd';

const { layers, mediaSizes } = theme;

export default ({ collapsed }: AdhesionAdProps) => ({
  container: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    margin: 0,
    width: '100vw',
    overflow: collapsed ? 'hidden' : 'unset',
    height: collapsed ? 0 : 50,
    opacity: collapsed ? 0 : 1,
    transition: 'all 150ms ease',
    boxShadow: '0 -3px 8px rgba(0, 0, 0, 0.1)',
    zIndex: layers.higher,
    background: 'rgba(255, 255, 255, 0.5)',

    [`@media screen and (min-width: ${mediaSizes.m}px)`]: {
      height: collapsed ? 0 : 90,
    },
  },

  fillAd: {
    height: '100%',
  },
});
